import { printf, toText } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { tryInt } from "../Utils.js";
import { toDateAndTimeStr, Tickets_tryGetColumnTypeName } from "../Locale.js";
import { Tickets_Audit_Prop__ToString_12C6553D, Tickets_Audit_Prop_FromUnionColumnId_Z524259A4 } from "../Shared/Shared.js";
import { some, unwrap, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { AuditLog_$reflection, AuditLog } from "../Shared/ApiDataTypes.js";
import { createElement } from "react";
import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { API_Tickets_TicketAuditLogs } from "../Shared/Urls.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { obj_type, array_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { testRedirect, extraCoders } from "../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { singleton, cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { createObj, uncurry2 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { take, sortByDescending, map as map_1 } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { DialogActions, Button, DialogContent, DialogTitle, Dialog, TableBody, TableHead, TableCell, TableRow, Table } from "@mui/material";
import { compare } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { empty as empty_1, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { sectionHeader } from "../TicketHelpers.js";
import { loadingIndicatorSmall } from "../ViewHelpers.js";

function translateUpdateUnionTypes(lang, locale, log) {
    let format;
    if (lang.tag === 1) {
        const clo_3 = toText(printf("The value %s has been changed from \"%s\" to \"%s\""));
        format = ((arg_3) => {
            const clo_4 = clo_3(arg_3);
            return (arg_4) => {
                const clo_5 = clo_4(arg_4);
                return clo_5;
            };
        });
    }
    else {
        const clo = toText(printf("Verdien %s er blitt endret fra \"%s\" til \"%s\""));
        format = ((arg) => {
            const clo_1 = clo(arg);
            return (arg_1) => {
                const clo_2 = clo_1(arg_1);
                return clo_2;
            };
        });
    }
    const input_9 = log.ColumnId;
    if (input_9 == null) {
        return undefined;
    }
    else {
        const columnId = input_9 | 0;
        const getText = (arg_6) => {
            const input_1 = tryInt(arg_6);
            if (input_1 == null) {
                return undefined;
            }
            else {
                return Tickets_tryGetColumnTypeName(locale, columnId, input_1);
            }
        };
        const input_7 = Tickets_Audit_Prop_FromUnionColumnId_Z524259A4(columnId);
        if (input_7 == null) {
            return undefined;
        }
        else {
            const columnName = Tickets_Audit_Prop__ToString_12C6553D(input_7, lang);
            const input_5 = getText(log.OldValue);
            if (input_5 == null) {
                return undefined;
            }
            else {
                const _arg_2 = input_5;
                const input_3 = getText(log.NewValue);
                if (input_3 == null) {
                    return undefined;
                }
                else {
                    return format(columnName)(_arg_2)(input_3);
                }
            }
        }
    }
}

function updateAuditLogs(lang, locale, log) {
    return new AuditLog(log.Id, log.Action, log.Entity, log.EntityId, log.EntityTypeId, log.EditDate, log.ColumnId, log.OldValue, log.NewValue, defaultArg(translateUpdateUnionTypes(lang, locale, log), log.ChangesText), log.Editor);
}

export function ChangeLog(changeLogInputProps) {
    let elems_8;
    const isUpdated = changeLogInputProps.isUpdated;
    const ticketId = changeLogInputProps.ticketId;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setViewLogs = patternInput[1];
    const patternInput_1 = reactApi.useState(true);
    const setLoadingLogs = patternInput_1[1];
    const loadingLogs = patternInput_1[0];
    const patternInput_2 = reactApi.useState([]);
    const logs = patternInput_2[0];
    const dependencies = [isUpdated];
    reactApi.useEffect(() => {
        let properties_2;
        const url = API_Tickets_TicketAuditLogs(ticketId);
        if (loadingLogs ? true : !isUpdated) {
            setLoadingLogs(true);
            let pr_2;
            let pr_1;
            const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(AuditLog_$reflection()), undefined, undefined);
            const data_1 = undefined;
            const caseStrategy_2 = undefined;
            const extra_2 = extraCoders;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg_1) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg_1, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(AuditLog_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_2) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_2), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
            }
            catch (exn) {
                pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
            pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
            pr_2.then((res) => {
                if (res.tag === 0) {
                    patternInput_2[1](map_1((log) => updateAuditLogs(ctx.Language, ctx.Locale, log), res.fields[0]));
                }
                else {
                    console.error(some(`TicketChangeLog.Could not fetch ticket audit logs ${ticketId}:`), res.fields[0]);
                }
                setLoadingLogs(false);
            });
        }
    }, dependencies);
    const changesTable = (x_1) => {
        let elements_4, children, elements, children_2;
        return MuiHelpers_createElement(Table, [["size", "small"], (elements_4 = [(children = singleton(MuiHelpers_createElement(TableRow, [(elements = [MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", ctx.Locale.t("Date")]]), MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", ctx.Locale.t("Ticket.Changes.Changes")]]), MuiHelpers_createElement(TableCell, [["variant", "head"], ["children", ctx.Locale.t("Ticket.Changes.ChangedBy")]])], ["children", reactApi.Children.toArray(Array.from(elements))])])), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children))]])), (children_2 = map_1((log_1) => {
            let input_1;
            const children_1 = ofArray([MuiHelpers_createElement(TableCell, [["children", toDateAndTimeStr(ctx.DateFnsLocale, log_1.EditDate)]]), MuiHelpers_createElement(TableCell, [["children", log_1.ChangesText]]), MuiHelpers_createElement(TableCell, [["children", defaultArg((input_1 = log_1.Editor, (input_1 == null) ? undefined : input_1.Email), "System")]])]);
            return MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_1))]]);
        }, sortByDescending((l) => l.EditDate, x_1, {
            Compare: compare,
        })), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_2))]]))], ["children", reactApi.Children.toArray(Array.from(elements_4))])]);
    };
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
    }], (elems_8 = toList(delay(() => {
        let elements_7, children_3, children_4;
        return append(singleton_1(MuiHelpers_createElement(Dialog, [["open", patternInput[0]], ["onClose", (_arg_4, v_1) => {
            setViewLogs(false);
        }], ["PaperProps", {
            style: {
                maxWidth: 90 + "vw",
            },
        }], (elements_7 = [MuiHelpers_createElement(DialogTitle, [["children", ctx.Locale.t("Ticket.Changes.ChangeLog")]]), (children_3 = singleton(changesTable(logs)), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children_3))]])), (children_4 = singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "contained"], ["color", "primary"], ["onClick", (_arg_5) => {
            setViewLogs(false);
        }], ["children", ctx.Locale.t("Close")]])), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_4))]]))], ["children", reactApi.Children.toArray(Array.from(elements_7))])])), delay(() => append(singleton_1(sectionHeader(ctx.Locale.t("Ticket.Changes.ChangeLog"))), delay(() => (loadingLogs ? singleton_1(loadingIndicatorSmall()) : append(singleton_1(changesTable((logs.length > 5) ? take(5, sortByDescending((l_1) => l_1.EditDate, logs, {
            Compare: compare,
        })) : logs)), delay(() => {
            let children_5;
            return (logs.length > 5) ? singleton_1((children_5 = singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "contained"], ["color", "primary"], ["children", ctx.Locale.t("Ticket.Changes.ViewAll")], ["onClick", (_arg_6) => {
                setViewLogs(true);
            }]])), createElement("div", {
                children: reactApi.Children.toArray(Array.from(children_5)),
            }))) : empty_1();
        })))))));
    })), ["children", reactApi.Children.toArray(Array.from(elems_8))])])));
}

